export class PublicationDateModel {
    constructor(
      public publicationId: string,
      public year: string,
      public publishDate: string,
      public volumeNumber: number,
      public issueNumber: number) {}
  }
